import React from "react";
import { withRouter } from "react-router-dom";
//import { useClearCache } from 'react-clear-cache';
import Snackbar from "./ui-containers/SnackBar";
import { localStorageGet, mapDispatchToProps, pushClevertapEvent, wrapRequestBody } from "./ui-utils/commons";
import { httpRequest } from "./ui-utils/api";
import validateWhoAmiResponse from "./ui-utils/whoami";
import MainRoutes from "./ui-routes/MainRoutes";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import LoadingOverlay from "react-loading-overlay";
import { Hidden } from "@material-ui/core";
import VideoCall from "./ui-molecules/Video";
import Idlecontainer from "./ui-molecules/Idlecontainer";
import SessionErrorScreen from "./ui-molecules/SessionErrorScreen";
import SessionBootstrapScreen from "./ui-molecules/SessionBootstrapScreen";
import "./App.css";
import { isEmpty } from "lodash";
import store from "./ui-redux/store";
import { setUserSession, clearUserSession } from "./ui-redux/user-session/actions";

class App extends React.Component {
  constructor(props) {
    super(props);
    const storedToken = localStorageGet("userInfo", "OAuthDetails.authToken");
    this.state = {
      reRender: false,
      sessionError: false,
      // Until _whoami succeeds, avoid rendering the app shell when a token exists (no permission flash).
      sessionReady: !storedToken,
    };
  }

  // check if url is for login page
  checkIfLoginURL = () => {
    const url = window.location.href;
    const home_index = url.indexOf('/#/')
    const string_after_slash = url.slice(home_index + 3, url.length-1) // '+3' to start after "/#/"
    const has_slash = string_after_slash.includes('/')
    return ( (!has_slash && string_after_slash.length === 0) || url.includes('login') ) ? true : false
  }

  componentDidMount = async () => {
    const { i18n, selectedLanguage, setAppData } = this.props;
    i18n.changeLanguage(selectedLanguage);
    const mdmsDataRes = localStorageGet("mdmsData");
    if (mdmsDataRes) {
      setAppData("mdmsData", JSON.parse(mdmsDataRes));
    }
    // check if session storage is empty
    // if empty then set userInfo in session storage
    const userDataFromLS = localStorageGet('userInfo');
    const userInfoSession = sessionStorage?.userInfoSession;
    if(userDataFromLS && !userInfoSession){ 
      sessionStorage.setItem('userInfoSession', userDataFromLS)
    }

    // Re-hydrate Redux from the server on every page refresh.
    // _whoami returns permissions from the DB — localStorage is never consulted for permissions.
    const storedToken = localStorageGet("userInfo", "OAuthDetails.authToken");
    if (storedToken) {
      try {
        const response = await httpRequest({
          endPoint: "auth-service/v1/_whoami",
          method: "post",
          instance: "instanceOne",
          requestBody: wrapRequestBody({}, "_whoami"),
          hasSpinner: false,
        });
        if (validateWhoAmiResponse(response)) {
          store.dispatch(setUserSession(response));
          this.setState({ sessionReady: true });
        } else {
          // Token invalid or user deactivated — clear session and show error screen
          localStorage.removeItem("userInfo");
          localStorage.setItem("loggedIn", "false");
          this.setState({ sessionError: true });
        }
      } catch (_) {
        // Network / server error — do NOT fall back to localStorage.
        // Show error screen so the user knows to retry or log in again.
        this.setState({ sessionError: true });
      }
    }
    
    // compare "uuid" -> in session and local-Storage
    window.addEventListener('focus', () => {
      if(sessionStorage?.userInfoSession){
        const sessionStorage_userInfo = JSON.parse(sessionStorage?.userInfoSession)
        const userInfo_from_ls = JSON.parse(localStorageGet('userInfo'))
        if(sessionStorage_userInfo?.User?.uuid !== userInfo_from_ls?.User?.uuid && !this.checkIfLoginURL()){
          window.location.reload()
        }
      }
    }); 
  }

  clearSessionAndLogin = () => {
    const { setAppData, history } = this.props;
    setAppData('communication.video', false);
    setAppData('communication.token', null);
    setAppData('administratorSummary', {});
    setAppData('clinicianPortal', {});
    setAppData('communication', {});
    setAppData('dashboard', {});
    setAppData('mevents', []);
    setAppData('patientPortal', {});
    setAppData('patients', {});
    setAppData('savepatient', {});
    setAppData('userProfile', '');
    window.localStorage.clear();
    store.dispatch(clearUserSession());
    this.setState({ sessionError: false, sessionReady: true }, () => {
      history.push('/login');
    });
  }

  endVideo = () => {
    const { setAppData } = this.props;
    
    // ENDING_A_CALL event
    pushClevertapEvent("ENDING_A_CALL")

    setAppData('communication.video', false);
    setAppData('communication.token', null);
    this.setState({ reRender: true })
  }
  render() {
    const { spinner, communication = {}, setAppData, errorChk } = this.props;
    const { endVideo, clearSessionAndLogin } = this;
    const { sessionError, sessionReady } = this.state;
    const { video, name, token, appointmentClinicians = [], roomId, vidChannel, pChatid ='' } = communication;

    if (sessionError) {
      return <SessionErrorScreen onLoginAgain={clearSessionAndLogin} />;
    }

    if (!sessionReady) {
      return <SessionBootstrapScreen />;
    }

    return (
      <div>
        <Hidden only={["md", "lg", "xl"]}>
          {window.location.href && window.location.href.includes('mobile-') || window.location.href.includes('reset-password') || window.location.href.includes('mfa-assistance')? 
          <MainRoutes />
          :
          <div className='mobile' />
          }
        </Hidden>
        <Hidden only={["xs", "sm"]}>
          <LoadingOverlay active={spinner}>
            <div>
              <MainRoutes />
              {((localStorageGet('loggedIn') && isEmpty(token) ) || errorChk) &&
                <Idlecontainer setAppData={setAppData}  errorChk={errorChk}/>
              }
              <Snackbar />
              {video &&
                <VideoCall
                  setAppData={setAppData}
                  endVideo={endVideo}
                  name={name}
                  token={token}
                  appointmentClinicians={appointmentClinicians}
                  roomId={roomId}
                  channel={vidChannel}
                  pChatid={pChatid}
                  communication={communication}
                />
              }
            </div>
          </LoadingOverlay>
        </Hidden>
      </div>
    );
  }
}
// const App= ({
//   spinner, 
//   communication = {}, 
//   setAppData,
//   selectedLanguage,
//   i18n
// }) => {
//   const { isLatestVersion, emptyCacheStorage } = useClearCache();
//   // eslint-disable-next-line
//   const [reRender, setRerender] = useState(false);
//   const { video, name, token, appointmentClinicians = [], roomId, vidChannel, pChatid ='' } = communication;
//   useEffect(()=>{
//     i18n.changeLanguage(selectedLanguage);
//     const mdmsDataRes = localStorageGet("mdmsData");
//     if (mdmsDataRes) {
//       setAppData("mdmsData", JSON.parse(mdmsDataRes));
//     }
//     // eslint-disable-next-line
//   },[reRender]);

//   function endVideo(){
//     setAppData('communication.video', false);
//     setAppData('communication.token', null);
//     setRerender(!reRender);
//   }
//   return (
//     <div>
//       {!isLatestVersion ?
//        (
//         <p>
//           {/* eslint-disable-next-line */}
//           <a
//             href="/login"
//             onClick={e => {
//               e.preventDefault();
//               emptyCacheStorage();
//               window.location.reload()
//             }}
//           >
//             Update version
//           </a>
//         </p>
//       ):
//       <div>
//         <Hidden only={["md", "lg", "xl"]}>
//           <div className='mobile' />
//         </Hidden>
//         <Hidden only={["xs", "sm"]}>
//           <LoadingOverlay active={spinner}>
//             <div>
//               <MainRoutes />
//               <Snackbar />
//               {video &&
//                 <VideoCall
//                   setAppData={setAppData}
//                   endVideo={endVideo}
//                   name={name}
//                   token={token}
//                   appointmentClinicians={appointmentClinicians}
//                   roomId={roomId}
//                   channel={vidChannel}
//                   pChatid={pChatid}
//                   communication={communication}
//                 />
//               }
//             </div>
//           </LoadingOverlay>
//         </Hidden>
//       </div>
//       }
//     </div>
//   );
// };
const mapStateToProps = ({ screenConfiguration }) => {
  const { preparedFinalObject = {} } = screenConfiguration;
  const { spinner = false, selectedLanguage = "en", communication, errorChk } = preparedFinalObject;
  return { spinner, selectedLanguage, communication, errorChk };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(App)));
